<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-snackbar v-model="snackbar.visible"
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    top>
            {{snackbar.text}}
        </v-snackbar>
        <v-row
                align="center"
                justify="center"
        >
            <v-col
                    cols="12"
                    sm="8"
                    md="4"
            >
                <v-card class="elevation-12">
                    <v-toolbar
                            color="primary"
                            dark
                            flat
                    >
                        <v-toolbar-title>Passwort zurücksetzen</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form
                                ref="resetForm"
                        >
                            <v-text-field
                                    label="Password"
                                    name="email"
                                    prepend-icon="lock"
                                    type="password"
                                    v-model="password"
                                    @keypress="keypress"
                            />
                            <v-text-field
                                    label="Password wiederholen"
                                    name="email"
                                    prepend-icon="lock"
                                    type="password"
                                    v-model="passwordRepeat"
                                    @keypress="keypress"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="reset" :loading="loading">Password zurücksetzen</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {accountService} from "../services/accountService";
    export default {
        name: "Reset",
        data() {
            return {
                password: "",
                passwordRepeat: "",
                snackbar: {
                    visible: false,
                    text: "",
                    timeout: 5000,
                    color: ""
                },
                loading: false
            }
        },
        methods: {
            keypress(event) {
                if(event.key === "Enter")
                    this.reset()
            },
            reset() {
                if(this.password !== this.passwordRepeat) {
                    this.snackbar.visible = true;
                    this.snackbar.text = "Passwörter stimmen nicht überein."
                    this.snackbar.color = "error";
                    return;
                }
                if(this.password.length < 8) {
                    this.snackbar.visible = true;
                    this.snackbar.text = "Das Passwort muss mindestens 8 Zeichen lang sein."
                    this.snackbar.color = "error";
                    return;
                }
                this.loading = true;
                let self = this;
                accountService.resetPassword(this.$route.query.token, this.password).then(() => {
                    self.loading = false;
                    self.email = ""
                    self.snackbar.visible = true;
                    self.snackbar.text = "Passwort erfolgreich zurückgesetzt"
                    self.snackbar.color = "success";
                }).catch(() => {
                    self.loading = false;
                    self.snackbar.visible = true;
                    self.snackbar.text = "Ein Fehler ist aufgetreten"
                    self.snackbar.color = "error";
                })
            }
        },
      created() {
        document.title = "Passwort zurücksetzen";
      }
    }
</script>

<style scoped>

</style>